
import React from 'react';
import { WheelPicker, WheelPickerWrapper } from '@ncdai/react-wheel-picker';

interface WheelPickerOption {
  label: string;
  value: string;
}

const createArray = (length: number, add = 0): WheelPickerOption[] =>
  Array.from({ length }, (_, i) => {
    const value = i + add;
    return {
      label: value.toString().padStart(2, "0"),
      value: value.toString(),
    };
  });

const hourOptions = createArray(12, 1);
const minuteOptions = createArray(60);
const meridiemOptions: WheelPickerOption[] = [
  { label: "AM", value: "AM" },
  { label: "PM", value: "PM" },
];

interface UplivionWheelPickerProps {
  onSelectionChange?: (selections: { hour: string; minute: string; meridiem: string }) => void;
}

export function UplivionWheelPicker({ onSelectionChange }: UplivionWheelPickerProps) {
  return (
    <div className="w-56 rounded-lg border border-zinc-200 bg-white px-1 shadow-xs dark:border-zinc-700/80 dark:bg-zinc-900 *:data-rwp:first:*:data-rwp-highlight-wrapper:rounded-s-md *:data-rwp:last:*:data-rwp-highlight-wrapper:rounded-e-md" data-rwp-wrapper="true">
      <WheelPickerWrapper>
        <WheelPicker 
          options={hourOptions} 
          infinite 
          onValueChange={(value) => console.log('Hour:', value)}
        />
        <WheelPicker 
          options={minuteOptions} 
          infinite 
          onValueChange={(value) => console.log('Minute:', value)}
        />
        <WheelPicker 
          options={meridiemOptions}
          onValueChange={(value) => console.log('Meridiem:', value)}
        />
      </WheelPickerWrapper>
    </div>
  );
}
